import React from "react";
import { Route, Redirect } from "react-router-dom";
import store from "./store.js";
import { setAuth } from "./action/auth";
import Sidebar from "components/Navbars/Sidebar.js";

const styles = { paddingLeft: "250px" };

const layoutStyles = {
  display: "flex",
  alignItems: "stretch",
};

const checkLogin = (path) => {
  console.log("window.location", window.location);
  console.log("ProtectedRoute.js path", path);

  let ud = JSON.parse(localStorage.getItem("ud"));
  if (!!ud) {
    // ud = JSON.parse(localStorage.getItem("ud"));
    if (ud["master"]) {
      store.dispatch(setAuth(ud));
      return true;
    } else {
      store.dispatch(setAuth(null));
      return false;
    }
  }

  return false;
};

const PrivateRoute = ({ component: Component, exact, ...rest }) => (
  <Route
    exact
    {...rest}
    render={(props) =>
      checkLogin(rest.path) ? (
        // <>
        //   {" "}
        //   <Sidebar />{" "}
        //   <div style={styles}>
        //     <Component {...props} />{" "}
        //   </div>{" "}
        // </>
        <div style={layoutStyles}>
          <Sidebar />
          <div className="component-container">
            <Component {...props} />
          </div>
        </div>
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);

export default PrivateRoute;
